var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-startPractice" },
    [
      _c(
        "div",
        {
          staticClass: "leftBox",
          attrs: { id: "leftBox" },
          on: { scroll: _vm.getScrollTop },
        },
        [
          _c("i", {
            staticClass: "iconfont iconfanhui",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          }),
          _c("div", { staticClass: "title f24" }, [
            _vm._v(_vm._s(_vm.specialtyName)),
          ]),
          _c(
            "div",
            { class: _vm.fontClass },
            [
              _vm.currentQuestion.questionType === "填空题样式"
                ? _c("FillBlank", {
                    ref: "topicRef",
                    attrs: {
                      index: _vm.currentIndex,
                      datas: _vm.currentQuestion,
                      isAnalysis: _vm.isAnalysis,
                    },
                    on: {
                      showAnalysis: function ($event) {
                        _vm.showAnalysis = !_vm.showAnalysis
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentQuestion.questionType === "单选题样式"
                ? _c("ChoiceOne", {
                    ref: "topicRef",
                    attrs: {
                      index: _vm.currentIndex,
                      datas: _vm.currentQuestion,
                      isAnalysis: _vm.isAnalysis,
                    },
                    on: {
                      next: _vm.next,
                      showAnalysis: function ($event) {
                        _vm.showAnalysis = !_vm.showAnalysis
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentQuestion.questionType === "多选题样式"
                ? _c("ChoiceMultiple", {
                    ref: "topicRef",
                    attrs: {
                      index: _vm.currentIndex,
                      datas: _vm.currentQuestion,
                      isAnalysis: _vm.isAnalysis,
                    },
                    on: {
                      showAnalysis: function ($event) {
                        _vm.showAnalysis = !_vm.showAnalysis
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentQuestion.questionType === "判断题样式"
                ? _c("Judge", {
                    ref: "topicRef",
                    attrs: {
                      index: _vm.currentIndex,
                      datas: _vm.currentQuestion,
                      isAnalysis: _vm.isAnalysis,
                    },
                    on: {
                      next: _vm.next,
                      showAnalysis: function ($event) {
                        _vm.showAnalysis = !_vm.showAnalysis
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentQuestion.questionType === "简答题样式"
                ? _c("Subjective", {
                    ref: "topicRef",
                    attrs: {
                      index: _vm.currentIndex,
                      datas: _vm.currentQuestion,
                      isAnalysis: _vm.isAnalysis,
                    },
                    on: {
                      showAnalysis: function ($event) {
                        _vm.showAnalysis = !_vm.showAnalysis
                      },
                    },
                  })
                : _vm._e(),
              _vm.currentQuestion.questionType === "一题多问样式"
                ? _c("QuestionAsk", {
                    ref: "topicRef",
                    attrs: {
                      isAnalysis: _vm.isAnalysis,
                      index: _vm.currentIndex,
                      scrollTop: _vm.scrollTop,
                      datas: _vm.currentQuestion,
                    },
                    on: { viewScroll: _vm.viewScroll },
                  })
                : _vm._e(),
              _vm.currentIndex !== _vm.datas.topicList.length &&
              !["单选题样式", "判断题样式"].includes(
                _vm.currentQuestion.questionType
              )
                ? _c("div", { staticClass: "submit mat20" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.next(false)
                          },
                        },
                      },
                      [_vm._v("下一题")]
                    ),
                  ])
                : _vm._e(),
              _c("QuestionAnalysis", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAnalysis,
                    expression: "showAnalysis",
                  },
                ],
                ref: "questionAnalysis",
                attrs: { analysisDatas: _vm.currentQuestion },
                on: { collectChange: _vm.updateCollect },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "mat20" },
        [
          _c("AnswerSheet", {
            attrs: {
              isAnalysis: false,
              datas: _vm.answerSheetGroupDTOS,
              currentId: _vm.currentQuestionId,
              total: _vm.totalSum,
            },
            on: {
              change: _vm.jumpTo,
              submit: _vm.submit,
              isEmpty: _vm.isEmpty,
              handleScroll: _vm.handleScroll,
            },
          }),
        ],
        1
      ),
      _c("ComponentDialog1", {
        attrs: {
          icon: _vm.scoreDialog.icon,
          title: _vm.scoreDialog.title,
          score: _vm.scoreDialog.score,
          visible: _vm.isScoreVisible,
          iconPosition: "left-top",
          showCancelBtn: _vm.scoreDialog.showCancelBtn,
          confirmText: "查看解析",
        },
        on: {
          "update:visible": function ($event) {
            _vm.isScoreVisible = $event
          },
          confirm: _vm.scoreConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }